export default "__VITE_ASSET__5e191c34__"